import { Provider } from 'jotai'
import { useMatch } from 'react-router-dom'
import { ErrorBoundary } from 'common/components/ErrorBoundary/ErrorBoundary'
import PageError from 'components/ErrorPages/PageError'

import { StandardLayout } from '@sequencehq/core-components'

import { useStandardLayoutModalPortalRoot } from 'components/Layout/StandardLayoutModalPortalRoot'
import { automationsPaths } from 'Automations/router'
import { usePopulateResolvedNodeDefinitions } from 'Automations/nodeDefinitions'

import { AutomationExecutionsInbox } from './components'
import { AutomationExecutionSummary } from './executionSummary'
import { useSelectedAutomationExecution } from './hooks/useSelectedAutomationExecution'
import { LegacyExecutionPreview } from './components/legacyWorkflows/LegacyExecutionPreview'

export const AutomationExecutionsHistory = () => {
  const isOpen = Boolean(
    useMatch({ path: automationsPaths.executionHistory(), end: false })
  )
  const portalTarget = useStandardLayoutModalPortalRoot()

  if (!isOpen) {
    return null
  }

  return (
    <StandardLayout
      asModal
      portalTarget={portalTarget}
      data-testid="automations.management.executionsHistory"
      header={null}
      content={
        <Provider>
          <ExecutionsHistoryContent />
        </Provider>
      }
    />
  )
}

const ExecutionsHistoryContent = () => {
  const { selectedAutomationExecution, isLegacyExecution, legacyWorkflowId } =
    useSelectedAutomationExecution()

  // Resolve node definitions once into the provider's atom so execution
  // summaries can read concrete definitions (incl. the async start nodes)
  // synchronously, mirroring the watchtower inbox root.
  usePopulateResolvedNodeDefinitions()

  const preview = isLegacyExecution ? (
    <LegacyExecutionPreview workflowId={legacyWorkflowId} />
  ) : (
    <AutomationExecutionSummary
      automationExecutionId={selectedAutomationExecution?.id ?? null}
    />
  )

  return (
    <StandardLayout.SplitContent
      hideOuterBorders
      columns="auto 1fr"
      leadingSide={<AutomationExecutionsInbox />}
      trailingSide={
        <ErrorBoundary
          name="AutomationsManagementExecutionsPreview"
          fallback={PageError}
        >
          {preview}
        </ErrorBoundary>
      }
    />
  )
}
